import axios from 'axios';
import * as endPoints from '../../../Constants/Endpoints'

export function GetSitePreview(siteId) {

    return axios.get(
        process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.SitePreview,
    {
        params: {siteId},
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true
    });
}
